<template>
  <v-container class="order-list-view">
    <v-row class="pa-0">
      <v-subheader>
        {{ lang.orders.view.order_title }}
        <div style="position: absolute; right: 20px;">
          <span class="t-12">
            <v-progress-circular
              color="indigo"
              :value="100"
              :size="9"
              class="mx-1 mb-1"
            />
            Produto
          </span>
          <span class="t-12">
            <v-progress-circular
              color="pink"
              :value="100"
              :size="9"
              class="mx-1 mb-1"
            />
            Serviço
          </span>
        </div>
      </v-subheader>
      <v-container
        class="order-list-view-container pa-0"
        v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
      >
        <div>
          <v-row
            v-for="(catalog, i) in order.list"
            :key="i"
            class="catalog-row"
          >
            <v-col cols="12" class="catalog-col">
              <v-row
                v-for="(row, i_) in catalog"
                :key="i_"
                class="order-row"
              >
                <v-col cols="12" class="order-col">
                  <v-row class="order-header">
                    <v-col cols="9" class="title-col pb-0">
                      <v-row class="order-title pb-0">
                        <span class="item-title">
                          <v-progress-circular
                            :color="(i === 'items' ? 'indigo' : 'pink')"
                            :value="100"
                            :size="9"
                            class="mr-2"
                          />
                          <strong>{{ `${getCat(row)}${row.title} x${row.qty}` }}</strong>
                        </span>
                        <span class="dots"></span><br />
                      </v-row>
                      <v-row class="order-subtitle mx-0">
                        {{ row.description }}
                      </v-row>
                    </v-col>
                    <v-col cols="3" v-if="permissions.orders.viewprices" class="price-col">
                      <p class="text-lg-right unity-price">
                        Un. {{ formatCurrency(row.price) }}
                      </p>
                      <p class="text-lg-right subtotal-price">
                        <span>x{{ row.qty }}</span>
                        {{ formatCurrency(parseFloat(row.price) * row.qty) }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="row.adt.length > 0" class="additional">
                    <v-col cols="15" class="pa-0">
                      <v-subheader class="additional-title">{{ lang.orders.new.order.additional }}:</v-subheader>
                      <v-row
                        v-for="(adt, i) in row.adt"
                        :key="`A-${i}`"
                        class="adt-row"
                      >
                        <v-col cols="12" class="adt-title">
                          <span>{{ `- ${adt.title} x${adt.qty}` }}</span>
                          <span class="dots"></span>
                          <span class="adt-price text-lg-right">{{ formatCurrency(parseFloat(adt.total) * row.qty) }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="order-footer">
                    <v-col cols="9" class="pb-0">
                      <p class="order-subtitle" v-if="row.obs"><i>* {{ row.obs }}</i></p>
                    </v-col>
                    <v-col cols="3" v-if="permissions.orders.viewprices" class="price-col">
                      <p class="text-lg-right final-price">{{ formatCurrency(row.total) }}</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <v-row class="total-row">
        <v-col cols="12" class="order-total">
          <v-row>
            <v-col cols="6">
              <i v-if="order.obs">* {{ order.obs }}</i>
            </v-col>
            <v-col cols="6" v-if="permissions.orders.viewprices" class="pr-0">
              <v-row>
                <v-col cols="6" class="prices">
                  <p class="text-lg-right subtotal">{{ lang.orders.new.subtotal }}: </p>
                </v-col>
                <v-col cols="6" class="prices">
                  <p class="text-lg-right subtotal">{{ formatCurrency(order.subtotal) }}</p>
                </v-col>
              </v-row>
              <v-row v-for="(pay_row, index) in order.payable" :key="index">
                <v-col cols="6" class="prices">
                  <p class="text-lg-right subtotal">{{ pay_row.title }}: </p>
                </v-col>
                <v-col cols="6" class="prices">
                  <p class="text-lg-right subtotal">{{ formatCurrency(pay_row.price) }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="prices">
                  <p class="text-lg-right total"><strong>{{ lang.orders.datatable.headers.total }}: </strong></p>
                </v-col>
                <v-col cols="6" class="prices">
                  <p class="text-lg-right total"><strong>{{ formatCurrency(order.total) }}</strong></p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    getCat (item) {
      item.cat_name = (item.cat_name || '')
      item.parent_cat_name = (item.parent_cat_name || '')
      if (item.cat) {
        return (item.parent_cat !== item.cat ? `(${item.parent_cat_name} > ${item.cat_name}) ` : `(${item.cat_name}) `)
      }
      return ''
    }
  }
}
</script>

<style src="../styles/list_view.scss" lang="scss"></style>
